import { Route, Routes } from "react-router-dom";

import { QuickTable, QuickTableFilterTabs } from "../../components";
import { IProcessorBalanceViewProps } from "./InterProcessorTransfers";
import { interProcessorBalanceTransfersDisplayFormatter } from "./interProcessorBalanceTransfersDisplayFormatter";
import { MoveFundsForm } from "./MoveFundsForm";

export const View = (props: IProcessorBalanceViewProps) => {
  return (
    <>
      <QuickTable
        id="interProcessorBalanceTransfersTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        // renderDetail={(item) => <ProcessorBalanceListDetail tx={item} />}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={interProcessorBalanceTransfersDisplayFormatter}
        createNewButtonText="Move Funds"
        openCreateNewModal={props.openCreateNewModal}
        onExport={props.onExport}
        openDetailsModal={props.openDetailsModal}
      />

      <Routes>
        <Route
          path="/move-funds"
          element={<MoveFundsForm refreshTable={props.refreshTable} />}
        />
      </Routes>
    </>
  );
};
